import { Snackbar, Typography } from '@mui/material'
import { useState } from 'react'
import { Trans } from 'react-i18next'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { Link } from 'settle-ui/components/Link/Link'
import { logEvent } from 'lib/tracking/segment'
import { type ScheduleDemoDialogProps, ScheduleDemoDialog } from './dialogs/ScheduleDemoDialog/ScheduleDemoDialog'
import { SCHEDULE_DEMO_MODAL_CLOSE } from './ScheduleDemoLink.events'

export type ScheduleDemoLinkProps = Pick<ScheduleDemoDialogProps, 'url'>

export const ScheduleDemoLink: React.FC<ScheduleDemoLinkProps> = ({ url }) => {
  const [isDemoOpen, setIsDemoOpen] = useState(false)
  const handleOpen = () => setIsDemoOpen(true)
  const handleClose = () => {
    setIsDemoOpen(false)
    logEvent(SCHEDULE_DEMO_MODAL_CLOSE)
  }

  return (
    <>
      <Snackbar
        open={true}
        transitionDuration={0}
        message={
          <>
            <CalendarTodayIcon
              sx={(theme) => ({
                mr: theme.spacing(0.5),
                fontSize: theme.spacing(2),
                [theme.breakpoints.up('sm')]: {
                  fontSize: theme.spacing(3),
                },
              })}
            />
            <Typography
              variant="body2"
              sx={(theme) => ({
                '& span': {
                  display: 'none',
                  [theme.breakpoints.up('sm')]: {
                    display: 'inline',
                  },
                },
              })}
            >
              <Trans
                i18nKey="letUsShowYouAroundScheduleADemo"
                components={{
                  a: <Link color="linkPrimary" onClick={handleOpen} />,
                }}
              />
            </Typography>
            <ArrowForwardIcon
              sx={(theme) => ({
                fontSize: theme.spacing(2),
                color: theme.tokens.ThemeColorCommonOnPrimaryLink,
              })}
            />
          </>
        }
        sx={(theme) => ({
          left: 'auto !important',
          minWidth: 'auto',
          width: 'min-content',
          right: theme.spacing(4),
          bottom: theme.spacing(3.5),
          zIndex: theme.zIndexes.floatingActionPanel,
          [theme.breakpoints.up('sm')]: {
            right: '50%',
            transform: 'translateX(50%)',
          },
        })}
        ContentProps={{
          sx: (theme) => ({
            padding: theme.spacing(1.5, 2.5),
            borderRadius: theme.spacing(8),
            background: theme.tokens.ThemeColorCommonPrimary,
            boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.20), 0px 4px 12px 0px color(display-p3 0 0 0 / 0.20)',
            '& .MuiSnackbarContent-message': {
              padding: 0,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: theme.spacing(0.5),
              whiteSpace: 'nowrap',
            },
          }),
        }}
      />
      <ScheduleDemoDialog url={url} open={isDemoOpen} onClose={handleClose} />
    </>
  )
}
